<div class="content-block">
  <ul class="kocke">
    <li class="dx-card bojaKockeAktivna" [ngClass]="{'bojaKockeAktivna': item.uci_aktivna == 1, 'bojaKockeNeaktivna': item.uci_aktivna == 0}" *ngFor="let item of ucionice; let i = index" (click)="jednaUcionica(item)">
        <p class="nazivSubjekta">{{ item.uci_naziv }}</p>
        <p *ngIf="prava != '3'" class="brojljudi">Polaznici: {{ item.brojPolaznika }}</p>
        <dx-button icon="paste" class="slika"></dx-button>
        <!-- <dx-button icon="edit" class="uredi"></dx-button> -->
    </li>
  </ul>
</div>